export const TEAM_BUILDER_LS = 'teamBuilder';
